import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_DOMAIN } from '../utils/constants';
import { useRecoilValue } from 'recoil';
import { userData } from '../recoil/atom/userData';
import { impersonateData } from '../recoil/atom/impersonate';

const useGetAllNPSData = () => {
    const user = useRecoilValue(userData);

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const isImpersonating =
        sessionStorage.getItem("impersonate") === "true" &&
        sessionStorage.getItem("business");

    const endpointContext = isImpersonating ? `impersonate` : "nps-details";

    useEffect(() => {
        const token = isImpersonating
            ? sessionStorage.getItem("token")
            : localStorage.getItem("token");
        const fetchData = async () => {
            setLoading(true);
            try {
                const feedbackTypes = user?.feedbackTypes || [];
                const responses = await Promise.all(
                    feedbackTypes.map(type => axios.get(`${API_DOMAIN}/${endpointContext}`, {
                        params: isImpersonating
                            ? {
                                businessId: sessionStorage.getItem("business"),
                                feedbackType: type.toLowerCase(),
                            }
                            : { feedbackType: type.toLowerCase() },
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    )
                );
                setData(responses.map(res => res.data));
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        if (user?.feedbackTypes?.length) {
            fetchData();
        }
    }, [user]);

    return { data, loading, error };
};

export default useGetAllNPSData;